export default {

  App: {
    Title: 'PIRELLI'
  },

  Button: {
    View    : 'Προβολή',
    Close   : 'Κλείσιμο',
    Send    : 'Αποστολή',
    Yes     : 'Ναί',
    No      : 'Όχι',
    Ok      : 'Οκ',
    Next    : 'Επόμενο',
    Prev    : 'Προηγούμενο',
    Register: 'Εγγραφή',
  },

  Error: {
    Generic        : 'Υπήρξε κάποιο πρόβλημα. Παρακαλώ προσπαθήστε ξανά.',
    MaintenanceMode: 'Αυτή τη στιγμή εκτελούνται εργασίες. Παρακαλούμε δοκιμάστε αργότερα.',
  },

  Misc: {
    Locale   : 'Γλώσσα',
    CreatedAt: '@:Common.Button.Create',
    UpdatedAt: '@:Common.Button.Update',
    DeletedAt: '@:Common.Button.Delete',
  }
}
